<template>
  <div popup-modal>
    <!-- height: 이미지height + 39px  -->
    <div id="layer_popup" class="" style="left:1px; width:300px; height:389px;" v-if="popup">
      <div class="content">
        <div class="editArea">
          <img src="/images/popup/notice_250331.png" usemap="#btn" />
          <map name="btn">
            <area shape="rect" coords="48,195,253,230" href="https://pharm.boryung.co.kr/ir/Businessreport_view.do?SEQ=86&list_url=L2lyL0J1c2luZXNzcmVwb3J0LmRv" target="_blank">
            <area shape="rect" coords="48,240,253,275" href="https://pharm.boryung.co.kr/ir/Auditreport_view.do?SEQ=84&list_url=L2lyL0F1ZGl0cmVwb3J0LmRv" target="_blank">
          </map>
        </div>
        <div class="footer clearfix">
          <div class="f_left">
            <input type="checkbox" id="pCheck" @change="doTodayClose($event)" /><label for="pCheck">오늘은 이 창을 열지 않음</label> 
          </div>
          <div class="f_right">
            <a class="btn_close" @click="popup = false">닫기</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'

export default {
  name: 'PopupModal',
  data() {
    return {
      popup: true,
    }
  },
  watch: {
    $route() {
      console.log("cookie1="+VueCookies.get('popup250331'));
      if (VueCookies.isKey('popup250331')) {
        this.popup = false
      }
    }
  },
  methods: {
    doTodayClose(e) {
      if(e.target.checked == true) {
        VueCookies.set('popup250331', new Date());
        console.log('checked~~');
      } else {
        VueCookies.remove('popup250331');
        console.log('unchecked~~');
      }
    }
  },
  mounted() {
    console.log("cookie2="+VueCookies.get('popup250331'));
    if (VueCookies.isKey('popup250331')) {
      this.popup = false
    }

    // 게시날짜설정
    var _year = new Date().getFullYear();
    var _month = new Date().getMonth() + 1;
    var _date = new Date().getDate();
    _month < 10 ? _month = "0" + _month : _month;
    _date < 10 ? _date = "0" + _date : _date;
    
    var today = parseInt(_year + "" + _month + "" + _date);
    if(today > 20250406){
      this.popup = false
    }else{
      this.popup = true;
    }
  }
};
</script>


<style lang="less">
@import "~@/less/proj";
[popup-modal] {  
  #layer_popup {
    top:-60px; 
    position: absolute;
    background-color: #d5d5d5;
    z-index: 7;
  }
  #layer_popup.on {
      display: block;
  }
  #layer_popup .footer {
      position: absolute;
      bottom: 0;
      height: 39px;
      width: 100%;
      color:#ffffff;
      background-color: #666666;
  }
  #layer_popup .footer > div {
      font-size: 13px;
      line-height: 39px;
  }
  #layer_popup .footer .f_left input {
      width: 12px;
      height: 12px;
      background-color: #fff;
      vertical-align: initial;
      margin: 0 5px 0 10px;
  }
  #layer_popup .footer a.btn_close {
      display: block;
      padding-right: 16px;
      margin-right: 10px;
      background: url('/images/popup/btn_footer_close.gif') no-repeat right center;
  }
  #layer_popup .footer a.btn_close:hover {
      font-weight: bold;
      text-decoration: none;
  }
  .f_left {
    float: left;
  }
  .f_right {
    float: right;
  }
  #pCheck2 {color:#666666;font-size:100%;vertical-align:middle;-webkit-appearance: checkbox;}
  @media all and (max-width: 1024px) {
    #layer_popup {
        display:none !important;
    }
  }
  @media screen and(min-width:1240px) {
    #layer_popup {
        top:-109px;
    }
  }
}
</style>
